<template>
  <div class="goodsinfo" v-if="order_base">
    <!-- 标题 -->
    <ul class="goodsTit clearfix">
      <li>商品信息</li>
      <li>商品规格</li>
      <li>数量</li>
      <li>价格(元)</li>
    </ul>

    <!-- 商品列表 -->
    <ul class="goodsList clearfix" v-for="sku in order_skus">
      <li class="flex-row ite-c">
        <img :src="$baseUrl + '/' + sku.pic_url" alt="">
        <div class="goodTitWrap flex-col">
          <p class="info-tit">{{sku.goods_title}}</p>
          <p class="info-phone"><span>号码：</span>{{sku.goods_phone}}</p>
          <p class="setmeal">{{sku.goods_operator}}</p>
        </div>
      </li>
      <li><span>资费：</span>{{sku.goods_specs}}</li>
      <li>x {{sku.quantity}}</li>
      <li>￥{{sku.price}}</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "goodsInfo",
    props: {
      orderItem: {
        required: true,
        type: Object
      }
    },
    data() {
      return {
        order_skus: this.orderItem.order_skus,
        order_base: this.orderItem.order_base
      }
    },
    created() {
    },
    watch: {
      orderItem(val) {
        this.order_skus = val.order_skus
        this.order_base = val.order_base
      }
    }
  }
</script>

<style scoped>
  .goodsinfo {
    border: 1px solid #eee;
  }

  /*商品标题*/
  .goodsTit {
    background: #eee;
  }

  .goodsTit li {
    float: left;
    width: 9%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #3B3B3B;
    font-weight: bold;
    font-size: 12px;
  }

  .goodsTit li:first-child {
    width: 44%;
    text-align: left;
    text-indent: 12px;
  }

  .goodsTit li:nth-child(2){
    width: 37%;
  }

  /* 商品列表 */
  .goodsList {
    border-bottom: 1px solid #eee;
  }

  .goodsList li {
    float: left;
    width: 9%;
    height: 110px;
  }

  .goodsList li + li {
    border-left: 1px solid #eee;
  }

  .goodsList li:first-child {
    width: 44%;
  }


  .goodsList li:first-child img {
    width: 88px;
    height: 88px;
    margin-left: 12px;
    margin-right: 8px;
    background: #f9f9f9
  }

  .goodsList li:first-child .goodTitWrap {
    width: 250px;
    height: 88px;
    color: #B7B2AF;
    font-size: 12px;
  }

  .goodTitWrap .info-tit {
    color: #3B3B3B;
    /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; */
    /* autoprefixer: off */
    /* autoprefixer: on */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 4px;
  }
  .goodTitWrap .info-phone {
    width: 100%;
    color: #3B3B3B;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 35px;
  }
  .goodTitWrap .info-phone span {
    color: #B7B2AF;
  }

  .goodsList li:nth-child(2){
    width: 37%;
  }

  .goodsList li + li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #3B3B3B;
    font-size: 12px;
  }

  .goodsList li:nth-child(2){
    color: #B7B2AF;
    padding: 0 8px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }
  .goodsList li:nth-child(2) span{
    width: 100%;
    text-align: left;
    color: #333333;
  }


  .goodsList li:nth-child(4) .discount {
    color: #B7B2AF;
    margin-top: 5px;
  }

  .goodsList li:last-child {
    color: #DF0000;
  }
</style>
